var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 9H17.7296C12.2696 9 9.01465 12.255 9.01465 17.715V30.27C9.01465 35.73 12.2696 38.985 17.7296 38.985H30.2846C35.7446 38.985 38.9996 35.73 38.9996 30.27V17.715C38.9996 12.255 35.7446 9 30.2846 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3504 30.7953C20.0704 30.0153 21.1804 30.0753 21.8104 30.9303L22.7104 32.1303C23.4154 33.0753 24.5853 33.0753 25.2903 32.1303L26.1754 30.9453C26.8054 30.1053 27.9154 30.0453 28.6354 30.8103C30.2104 32.4903 31.4854 31.9353 31.4854 29.5803V19.6353C31.4854 16.0803 30.6454 15.1953 27.3154 15.1953H20.6553C17.3253 15.1953 16.4854 16.0803 16.4854 19.6353V29.5803C16.5004 31.9053 17.7904 32.4603 19.3504 30.7953Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptSquare);
export default __webpack_public_path__ + "static/media/receiptSquare.c06b3749cc5a242df02bfa35afbb113e.svg";
export { ForwardRef as ReactComponent };